import PageHeader from '@/components/PageHeader';
import PersonMinimalForm from '@/forms/PersonMinimalForm';
import Container from '@/ui/components/Container';

const PersonNew = () => {
  return (
    <Container type="page">
      <PageHeader headingText="New Person" />

      <PersonMinimalForm />
    </Container>
  );
};

export default PersonNew;
